import { render, staticRenderFns } from "./ChangeStatusRecycle.vue?vue&type=template&id=a1bf1156&scoped=true"
import script from "./ChangeStatusRecycle.vue?vue&type=script&lang=js"
export * from "./ChangeStatusRecycle.vue?vue&type=script&lang=js"
import style0 from "./ChangeStatusRecycle.vue?vue&type=style&index=0&id=a1bf1156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bf1156",
  null
  
)

export default component.exports